import S from './inline-toast.module.scss';

interface Props {
  message: string;
  closeToast?: () => void;
}

const InlineToast = ({ message, closeToast }: Props) => {
  return (
    <div className={S.container}>
      <span className={S.message}>{message}</span>
      <button type='button' className={S.closeButton} onClick={closeToast} aria-label='Close'>
        ×
      </button>
    </div>
  );
};

export default InlineToast;
